import React from 'react';
import { connect } from 'react-redux';
import { LabelsSidebar } from '../labels_sidebar/LabelsSidebar';
import { Label, LabelEntityType, CreateLabelRequest } from '../../types/labels';
import { labelsOnPartsRestCrudThunksForSupplier } from '../../thunks/labels_thunks';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { RootState } from '../../reducers/root_reducer';
import { pickRandomLabelColor } from '../../constants/labelConstants';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';

interface OwnProps {
	onClose?: () => void;
	targetCollectionName: LabelEntityType;
	// Called after the label catalogue is successfully created/updated/deleted — lets
	// callers refetch dependents (part rows, the dropdown catalogue).
	onLabelsCatalogueSaved?: () => void | Promise<void>;
	// When provided, the per-label count becomes clickable — the parent closes the
	// sidebar and applies that label as the Parts index filter.
	onLabelCountClick?: (label: Label) => void;
}

// Parts flavor of the shared LabelsSidebar: dot icons, part-count accessor, the
// parts palette, and the parts labels slice/thunks. Reused by both the Parts index
// "Labels" button and the Add Label modal's EDIT button.
const PartsLabelsManagementPage: React.FC<any> = (props) => (
	<LabelsSidebar
		{...props}
		// Parts labels have no access-permission gating — anyone can manage them.
		canModifyLabels
		iconVariant="dot"
		getCount={(label) => nullSafeGetOrElse('associatedPartsCount', label, 0)}
		pickNewLabelColor={pickRandomLabelColor}
		deleteWarningEntityNoun="parts"
	/>
);

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
	labels: getRecordsForTargetCollection(state.labels, ownProps.targetCollectionName) || [],
	fetching: nullSafeGetOrElse(`${ownProps.targetCollectionName}.fetching`, state.labels, false),
});
const mapDispatchToProps = (dispatch: any, ownProps: OwnProps) => ({
	fetchAllLabels: () =>
		dispatch(
			labelsOnPartsRestCrudThunksForSupplier.read(
				{ no_pagination: true },
				ownProps.targetCollectionName,
				null,
				{
					sort_by: 'associatedPartsCount',
					order: 'desc',
				}
			)
		),
	// targetCollectionName is the 3rd create() arg (not the 2nd/primaryKey), so the new label is
	// added to that collection's recordsIds and shows up reactively in the sidebar AND the filter.
	createLabel: (label: CreateLabelRequest) =>
		dispatch(labelsOnPartsRestCrudThunksForSupplier.create(label, 'id', ownProps.targetCollectionName)),
	updateLabel: (label: Label) => dispatch(labelsOnPartsRestCrudThunksForSupplier.update(label)),
	// Catalogue deletes are explicit Save actions — skip the generator's default undo
	// delay so the post-save refetch can't race a pending DELETE.
	deleteLabel: (label: Label) =>
		dispatch(labelsOnPartsRestCrudThunksForSupplier.deleteImmediate({ id: label.id }, 'id')),
});

// @ts-ignore - Type inference issue with HOC composition, same pattern as PartsLabelCreationButton
export default connect(mapStateToProps, mapDispatchToProps)(PartsLabelsManagementPage);
